import React, { useState, useEffect, useContext } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import ClassDiaryForm from './Form';
import SmartCard from '../../../shared/components/SmartCard';
import classDiaryListBySmartFilterById, {
  classDiarySave,
} from '../../../shared/queries/ClassDiary';
import GraphQL from '../../../GraphQL';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import { studentListByFilter } from '../../../shared/queries/Student';
import {
  ATTACHMENT_TYPES,
  PRESENCE_TYPE,
} from '../../../shared/utils/constants';
import {
  professorSchedule,
  professorScheduleForClassDiary,
  professorScheduleDisabledDates,
} from '../../../shared/queries/TeacherRoom';
import {
  isNumber,
  resizeImage,
  upLoadFilePromise,
} from '../../../shared/utils/smartutils';
import SmartContext from '../../App/context/SmartContext';
import {
  findStudentAttendanceForClassDiary,
  saveStudentAttendanceAllByClassDiary,
} from '../../../shared/queries/StudentAttendance';

const ClassDiaryFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [dto, setDto] = useState({
    id: 0,
    files: [],
  });
  const [formOn, setFormOn] = useState(false);
  const [schoolClasses, setSchoolClasses] = useState([]);
  const [studentAttendance, setStudentAttendance] = useState([]);
  const context = useContext(SmartContext);
  const { handlerFileToUploadWithTus, haveFilesToUpload, removeFileByVimeoId } =
    context;
  const [subjects, setSubjects] = useState([]);
  const [disabledDates, setDisabledDates] = useState([]);

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const backClickHandler = () => {
    history.goBack();
  };

  const loadStudentsBySchoolClass = (schoolClass) => {
    showLoading();
    const filter = {
      id: 0,
      classes: schoolClass ? [schoolClass] : [],
      responsibles: [],
      menus: [],
      onlyActive: true,
    };
    const query = studentListByFilter(filter);
    return GraphQL(query, {})
      .then((res) => {
        res.studentListByFilter = res.studentListByFilter.map((item) => ({
          ...item,
        }));
        setStudentAttendance(res.studentListByFilter);
        hideLoading();
        return res.studentListByFilter;
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };
  const hiddenAllColumnsClassesSequence = (data) => {
    data.forEach((student) => {
      Object.keys(student).forEach((atr) => {
        if (isNumber(atr)) {
          const updatedAtr = student[atr];
          updatedAtr.hidden = true;
        }
      });
    });
  };

  const hiddenColumnClassesSequence = (student, classSequence) => {
    Object.keys(student).forEach((key) => {
      classSequence.forEach((sequence) => {
        if (isNumber(key) && sequence.classSequence !== isNumber(key)) {
          const reassigned = student[key];
          reassigned.hidden = true;
        }
      });
    });
  };

  const onChangeClassSequenceInStudentAttendance = (
    studentsMapped,
    classSequence
  ) => {
    let updatedStudentAttendance = studentsMapped || [...studentAttendance];
    if (classSequence) {
      updatedStudentAttendance = updatedStudentAttendance.map((student) => {
        const columnsByClassSequence = {};
        classSequence.forEach(({ value, label }) => {
          if (!student[value]) {
            columnsByClassSequence[value] = {
              attendanceType: PRESENCE_TYPE.PRESENT,
              value,
              label,
              classSequence: value,
              hidden: false,
            };
          } else if (student[value] && student[value].hidden) {
            columnsByClassSequence[value] = {
              ...student[value],
              attendanceType: PRESENCE_TYPE.PRESENT,
              hidden: false,
            };
          } else {
            columnsByClassSequence[value] = {
              ...student[value],
              hidden: false,
            };
          }
        });
        hiddenColumnClassesSequence(student, classSequence);
        return {
          ...student,
          ...columnsByClassSequence,
        };
      });
    } else {
      hiddenAllColumnsClassesSequence(updatedStudentAttendance);
    }
    setStudentAttendance(updatedStudentAttendance);
  };

  const createClassesSequencesLabelValue = (values) => {
    return values.map((sequence) => ({
      ...sequence,
      value: sequence,
      label: `${sequence}º ${t('general.single-class')}`,
    }));
  };

  const listStudentAttendance = async (
    dateInMilli,
    schoolClass,
    subjectId,
    classSequence
  ) => {
    const students = await loadStudentsBySchoolClass(schoolClass);
    showLoading();
    const query = findStudentAttendanceForClassDiary(
      dateInMilli,
      schoolClass.id,
      subjectId,
      classSequence
    );
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        const array = [];
        res.listStudentAttendanceForClassDiary.forEach((item) => {
          const sequence = item.classSequence;
          let obj = {};
          obj[sequence] = { ...item };
          obj = { ...obj, studentId: item.student.id };
          if (array.length) {
            const found = array.find(
              (value) => value.studentId === item.student.id
            );
            const index = array.findIndex(
              (value) => value.studentId === item.student.id
            );
            if (found) {
              array[index] = { ...found, ...obj };
            } else {
              array.push(obj);
            }
          } else {
            array.push(obj);
          }
        });
        const studentsMapped = students.map((student) => {
          const found = array.find((item) => item.studentId === student.id);
          if (found) {
            return {
              ...student,
              ...found,
            };
          }
          const attendance = { ...array[0] };
          attendance.attendanceType = PRESENCE_TYPE.PRESENT;
          return {
            ...attendance,
            ...student,
          };
        });
        setStudentAttendance(studentsMapped);
        if (!array.length) {
          onChangeClassSequenceInStudentAttendance(
            studentsMapped,
            createClassesSequencesLabelValue(classSequence)
          );
        }
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const createDto = (res) => {
    const updatedDto = { ...res };
    updatedDto.sequences = updatedDto.classSequence;
    updatedDto.files = updatedDto.files.map((file) => {
      return {
        preview: file.fileUrl,
        type: file.fileType,
        fileType: file.fileType,
        fileId: file.fileId,
        fileUrl: file.fileUrl,
        order: 0,
        communicationId: dto.id,
        id: 0,
        fileName: file.fileName,
        status: file.status,
      };
    });
    updatedDto.classSequence = createClassesSequencesLabelValue(
      updatedDto.classSequence
    );
    updatedDto.courseStep = updatedDto.schoolClass.courseStep;
    return updatedDto;
  };

  const findById = (id) => {
    showLoading();
    const query = classDiaryListBySmartFilterById(id);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        const updatedDto = createDto(res.classDiaryListBySmartFilter[0]);
        setDto(updatedDto);
        const { dateInMilli, subject, schoolClass, sequences } = updatedDto;
        listStudentAttendance(dateInMilli, schoolClass, subject.id, sequences);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const saveStudentAttendance = (values) => {
    showLoading();
    const query = saveStudentAttendanceAllByClassDiary(values);
    GraphQL(query, {})
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const saveClassDiary = (values, uploadedFiles, filesAlreadyToUploaded) => {
    const query = classDiarySave(values, uploadedFiles, filesAlreadyToUploaded);
    GraphQL(query, {
      workSubject: values.workSubject,
      description: values.description,
    })
      .then(() => {
        hideLoading();
        saveStudentAttendance(values);
      })
      .catch(() => {
        if (uploadedFiles && uploadedFiles.length) {
          for (let index = 0; index < uploadedFiles.length; index += 1) {
            const { uploadType, fileId } = uploadedFiles[index];
            if (uploadType === ATTACHMENT_TYPES.VIMEO) {
              removeFileByVimeoId(fileId);
            }
          }
        }
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('notifications.error'),
          t('errors.error-to-save')
        );
      });
  };

  const filesAlreadyToUploadedFilter = (files) => {
    return files.filter((file) => !file.lastModified);
  };

  const filesToUploadFilter = (files) => {
    return files.filter(
      (file) =>
        file.lastModified &&
        file.uploadType !== ATTACHMENT_TYPES.VIMEO &&
        file.uploadType !== ATTACHMENT_TYPES.IMAGE
    );
  };

  const filesTypeImageFilter = (files) => {
    return files.filter((file) => file.uploadType === ATTACHMENT_TYPES.IMAGE);
  };

  const resizeImageToUpload = (files) => {
    return files.map((file) =>
      resizeImage(file).then((res) => {
        return Object.assign(res, {
          uploadType: file.uploadType,
        });
      })
    );
  };

  const resolveFilesResize = (array, arrPromisesFilesTypeImage) => {
    return Promise.all(arrPromisesFilesTypeImage).then((uploadedFiles) =>
      array.concat(uploadedFiles)
    );
  };

  const handleSubmit = async (values) => {
    showLoading();
    const { files } = values;
    if (files.length) {
      const filesAlreadyToUploaded = filesAlreadyToUploadedFilter(files);
      let filesToUpload = filesToUploadFilter(files);
      const filesTypeImage = filesTypeImageFilter(files);
      const arrPromisesFilesTypeImage = await resizeImageToUpload(
        filesTypeImage
      );
      filesToUpload = await resolveFilesResize(
        filesToUpload,
        arrPromisesFilesTypeImage
      );
      const arrPromises = await filesToUpload.map((file) =>
        upLoadFilePromise(file).then(({ data }) => {
          return { ...file, ...data };
        })
      );
      await Promise.all(arrPromises)
        .then(async (uploadedFiles) => {
          const haveVideoFilesToUpload = haveFilesToUpload();
          if (haveVideoFilesToUpload) {
            const listFilesWithVimeoId = await handlerFileToUploadWithTus();
            const uploadedFilesWithVideo = [
              ...uploadedFiles,
              ...listFilesWithVimeoId,
            ];
            saveClassDiary(
              values,
              uploadedFilesWithVideo,
              filesAlreadyToUploaded
            );
          } else {
            saveClassDiary(values, uploadedFiles, filesAlreadyToUploaded);
          }
        })
        .catch((error) => {
          hideLoading();
          if (error.response) {
            showNotificationAutoDestroy(
              'danger',
              t('notifications.error'),
              t('notifications.upload-error')
            );
          }
        });
    } else {
      const haveVideoFilesToUpload = haveFilesToUpload();
      if (haveVideoFilesToUpload) {
        const listFilesWithVimeoId = await handlerFileToUploadWithTus();
        saveClassDiary(values, listFilesWithVimeoId);
      } else {
        saveClassDiary(values);
      }
    }
  };

  const createSchoolClasses = (value) => {
    let arrayList = [...value];
    arrayList = arrayList.map((item) => ({
      ...item,
      start: new Date(item.begin),
      end: new Date(item.end),
    }));
    const obj = {};
    arrayList.forEach((item) => {
      if (obj[item.schoolClass.id]) {
        obj[item.schoolClass.id] = [...obj[item.schoolClass.id], item];
      } else {
        obj[item.schoolClass.id] = [item];
      }
    });
    Object.keys(obj).forEach((classId) => {
      obj[classId] = [
        ...obj[classId],
        { classShift: obj[classId][0].schoolClass.classShift },
        { courseStep: obj[classId][0].schoolClass.courseStep },
        { schoolClass: obj[classId][0].schoolClass },
        { academicCalendar: obj[classId][0].schoolClass.academicCalendar },
      ];
    });
    const arrayOfSchoolClass = [];
    Object.keys(obj).forEach((classId) => {
      const newObj = {
        ...obj[classId].find((item) => item.subjects),
        ...obj[classId].find((item) => item.academicCalendar),
        ...obj[classId].find((item) => item.classShift),
        ...obj[classId].find((item) => item.courseStep),
        ...obj[classId].find((item) => item.dates),
        ...obj[classId].find((item) => item.schoolClass),
      };
      arrayOfSchoolClass.push(newObj);
    });
    return arrayOfSchoolClass;
  };

  const loadSubjectsForClassDiary = (schoolClass) => {
    showLoading();
    const query = professorScheduleForClassDiary(
      schoolClass.id,
      schoolClass.classShift.id
    );
    GraphQL(query, {})
      .then((res) => {
        if (res.professorScheduleForClassDiary) {
          const subjectMap = new Map();
          res.professorScheduleForClassDiary.forEach(
            (professorScheduleSubject) =>
              subjectMap.set(
                professorScheduleSubject.subject.id,
                professorScheduleSubject.subject
              )
          );
          const listOfSubjects = [...subjectMap.values()];
          setSubjects(listOfSubjects);
        }
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadData = () => {
    showLoading();
    const query = professorSchedule();
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        const arrayOfSchoolClass = createSchoolClasses(res.professorSchedule);
        setSchoolClasses(arrayOfSchoolClass);
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadProfessorScheduleDisabledDates = (schoolClassId, subjectId) => {
    showLoading();
    const query = professorScheduleDisabledDates(schoolClassId, subjectId);
    GraphQL(query, {})
      .then((res) => {
        hideLoading();
        if (res.professorScheduleDisabledDates) {
          res.professorScheduleDisabledDates =
            res.professorScheduleDisabledDates.map(
              (dtInMilli) => new Date(dtInMilli)
            );
        }
        setDisabledDates(res.professorScheduleDisabledDates);
      })
      .catch((error) => {
        console.error(error);
        hideLoading();
      });
  };

  useEffect(() => {
    const { location } = history;
    if (location && location.state) {
      const { state } = location;
      const updatedDto = {
        ...dto,
        dateInMilli: new Date(state.event.begin),
        subject: state.event.subject,
        schoolClass: state.event.schoolClass,
        classSequence: [
          {
            classSequence: state.event.classSequence,
            value: state.event.classSequence,
            label: `${state.event.classSequence}ª ${t('general.single-class')}`,
          },
        ],
      };
      setDto(updatedDto);
    }
  }, [history]);

  useEffect(() => {
    if (match.params.id && match.params.id > 0) {
      if (dto.id !== parseInt(match.params.id, 0)) {
        findById(match.params.id);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, [dto]);

  useEffect(() => {
    loadData();
  }, []);

  return (
    <SmartCard title={t('panels.class-diary')}>
      {formOn && (
        <ClassDiaryForm
          dto={dto}
          onSubmit={handleSubmit}
          backClickHandler={backClickHandler}
          schoolClasses={schoolClasses}
          studentAttendance={studentAttendance}
          onChangeStudentAttendance={setStudentAttendance}
          onChangeClassSequenceInStudentAttendance={
            onChangeClassSequenceInStudentAttendance
          }
          loadSubjectBySchoolClass={loadSubjectsForClassDiary}
          subjects={subjects}
          listStudentAttendance={listStudentAttendance}
          listDisabledDates={loadProfessorScheduleDisabledDates}
          disabledDates={disabledDates}
          showLoading={showLoading}
          hideLoading={hideLoading}
        />
      )}
    </SmartCard>
  );
};

ClassDiaryFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ClassDiaryFormHandler)
);
